<template>
  <div>
    <div>
      <form autocomplete="off" v-on:submit.prevent="prevent">
        <v-alert text type="warning" v-if="!addressCounter"><div v-html="$t('accountSettings.address.itWillBeMain')"></div></v-alert>
        <v-alert text type="info" v-if="form.main"><div v-html="$t('accountSettings.address.main')"></div></v-alert>
        <v-alert text type="warning" v-if="form.main"><div v-html="$t('accountSettings.address.wantChange')"></div></v-alert>

        <v-row>
          <v-col cols="12" md="7" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.adressIdent') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" large dense :placeholder="$t('accountSettings.address.exIdent')"
              v-model="form.label" @change="v$.form.label.$touch()" @blur="v$.form.label.$touch()" required counter="25"
              :error-messages="labelErrors"></v-text-field>
          </v-col>
          <v-col cols="12" md="5" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.zipCode') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" dense large v-model="form.zipCode" @change="changeZipCode()"
              @blur="changeZipCode()" required v-mask="countryConfig.zipCodeMask"
              :counter="this.countryConfig.zipCodeMask.length" :error-messages="zipCodeErrors"
              :loading="zipLoading"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="7" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.street') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" large dense v-model="form.street" @change="v$.form.street.$touch()"
              @blur="v$.form.street.$touch()" required counter="50" :error-messages="streetErrors"></v-text-field>
          </v-col>
          <v-col md="2" sm="6">
            <label class="py-2">{{ $t('accountSettings.address.number') }}</label>
            <v-text-field :disabled="form.main" class="my-2" large dense v-model="form.number" @change="v$.form.number.$touch()"
              @blur="v$.form.number.$touch()" required counter="10" :error-messages="numberErrors"></v-text-field>
          </v-col>
          <v-col md="3" sm="6">
            <label class="py-2">{{ $t('accountSettings.address.complement') }}</label>
            <v-text-field :disabled="form.main" class="my-2" dense large v-model="form.complement" @change="v$.form.complement.$touch()"
              @blur="v$.form.complement.$touch()" counter="20" :error-messages="complementErrors"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.neighborhood') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" dense large v-model="form.district" @change="v$.form.district.$touch()"
              @blur="v$.form.district.$touch()" required counter="50" :error-messages="districtErrors"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.city') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" dense large v-model="form.city" @change="v$.form.city.$touch()"
              @blur="v$.form.city.$touch()" required counter="50" :error-messages="cityErrors"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <label class="py-2">{{ $t('accountSettings.address.state') }} *</label>
            <v-text-field :disabled="form.main" class="my-2" dense large v-model="form.state" @change="v$.form.state.$touch()"
              @blur="v$.form.state.$touch()" required counter="50" :error-messages="stateErrors"
              v-if="countryConfig.code != 'BRA'"></v-text-field>
            <v-select :disabled="form.main" class="my-2" dense large v-model="form.state" @change="v$.form.state.$touch()" v-else
              @blur="v$.form.state.$touch()" required :items="states" item-text="label" item-value="state"
              :error-messages="stateErrors"></v-select>
          </v-col>
        </v-row>
      </form>
    </div>
    <div class="d-flex pt-6">
      <v-btn outlined color="red" v-if="item.id && !form.main" icon
        @click="removeDialog = true"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
      <v-spacer></v-spacer>
      <div>
        <v-btn text @click="$emit('cancel', item)" class="mr-1">{{ $t('accountSettings.address.cancel') }}</v-btn>
        <v-btn color="primary" elevation="0" class="" @click="save()" :disabled="form.main || (v$.$invalid && v$.$dirty)"
          :loading="loading">{{
            $t('accountSettings.address.saveAddress') }}</v-btn>
      </div>
    </div>
    <v-dialog v-model="removeDialog" elevation="0" max-width="480">
      <v-card elevation="0" max-width="480" class="mx-auto pa-3">
        <v-card-title>
          <v-avatar size="64" color="error" class="mx-auto"><v-icon large>mdi-trash-can-outline</v-icon></v-avatar>
        </v-card-title>
        <v-card-title class="text-nowrap">{{ $t('accountSettings.address.remove.confirm') }}</v-card-title>
        <v-card-actions class="justify-end">
          <v-btn text @click="removeDialog = false" :disabled="deleting">{{ $t('accountSettings.address.cancel')
          }}</v-btn>
          <v-btn color="error" elevation="0" @click="remove()" :disabled="deleting" :loading="deleting">{{
            $t('accountSettings.address.yesCancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import countries from '@/store/countries'
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import axios from 'axios'
export default {
  name: "AddressForm",
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      form: {
        label: { required, maxLength: maxLength(20) },
        street: { required, maxLength: maxLength(50) },
        number: { required, maxLength: maxLength(10) },
        complement: { maxLength: maxLength(20) },
        district: { required, maxLength: maxLength(50) },
        city: { required, maxLength: maxLength(50) },
        state: { required, maxLength: maxLength(50) },
        zipCode: { required, minLength: minLength(this.countryConfig.zipCodeMask.length) },
      }
    }
  },
  data() {
    return {
      zipLoading: false,
      deleting: false,
      removeDialog: false,
      loading: false,
      form: {
        label: "",
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        zipCode: "",
        contactTypeId: 1,
        country: "Brasil",
      },
      states: [
        {
          state: "AC",
          label: "Acre",
        },
        {
          state: "AL",
          label: "Alagoas",
        },
        {
          state: "AM",
          label: "Amazonas",
        },
        {
          state: "AP",
          label: "Amapá",
        },
        {
          state: "BA",
          label: "Bahia",
        },
        {
          state: "CE",
          label: "Ceará",
        },
        {
          state: "DF",
          label: "Distrito Federal",
        },
        {
          state: "ES",
          label: "Espírito Santo",
        },
        {
          state: "GO",
          label: "Goiás",
        },
        {
          state: "MA",
          label: "Maranhão",
        },
        {
          state: "MT",
          label: "Mato Grosso",
        },
        {
          state: "MS",
          label: "Mato Grosso do Sul",
        },
        {
          state: "MG",
          label: "Minas Gerais",
        },
        {
          state: "PA",
          label: "Pará",
        },
        {
          state: "PB",
          label: "Paraíba",
        },
        {
          state: "PR",
          label: "Paraná",
        },
        {
          state: "PE",
          label: "Pernambuco",
        },
        {
          state: "PI",
          label: "Piauí",
        },
        {
          state: "RJ",
          label: "Rio de Janeiro",
        },
        {
          state: "RN",
          label: "Rio Grande do Norte",
        },
        {
          state: "RS",
          label: "Rio Grande do Sul",
        },
        {
          state: "RO",
          label: "Rondônia",
        },
        {
          state: "RR",
          label: "Roraima",
        },
        {
          state: "SC",
          label: "Santa Catarina",
        },
        {
          state: "SP",
          label: "São Paulo",
        },
        {
          state: "SE",
          label: "Sergipe",
        },
        {
          state: "TO",
          label: "Tocantins",
        },
      ],
    };
  },
  props: {
    addressCounter: Number,
    item: {
      type: Object,
    },
  },
  // watch: {
  //   form: {
  //     deep: true,
  //     handler(value) {
  //       this.$emit("change", value);
  //       this.$emit("valid", !this.v$.$invalid);
  //     },
  //   },
  // },
  mounted() {
    this.form.country = this.countryConfig.name

    if (this.item) {
      const {
        label,
        main,
        street,
        number,
        complement,
        district,
        city,
        state,
        zipCode,
        contactTypeId,
      } = JSON.parse(JSON.stringify(this.item));
      this.form = {
        label: label,
        main: main,
        street: street,
        number: number,
        complement: complement,
        district: district,
        city: city,
        state: state,
        zipCode: zipCode,
        contactTypeId: contactTypeId,
      };
    }
  },
  //   watch: {
  //     field: {
  //       deep: true,
  //       handler() {
  //       },
  //     },
  //   },
  computed: {
    countryConfig() {
      return countries[this.$root.auth.whitelabel.country]
    },
    labelErrors() {
      const errors = [];
      if (!this.v$.form.label.$dirty) return errors;
      this.v$.form.label.maxLength.$invalid &&
        errors.push(
          this.$t('accountSettings.address.err.minIdentificantion')
        );
      this.v$.form.label.required.$invalid &&
        errors.push(this.$t('accountSettings.address.err.requiredIdent'))
      return errors;
    },
    streetErrors() {
      const errors = [];
      if (!this.v$.form.street.$dirty) return errors;
      this.v$.form.street.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthStreet'))
      this.v$.form.street.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredStreet'))
      return errors;
    },
    numberErrors() {
      const errors = [];
      if (!this.v$.form.number.$dirty) return errors;
      this.v$.form.number.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthNumber'))
      this.v$.form.number.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredNumber'))
      return errors;
    },
    complementErrors() {
      const errors = [];
      if (!this.v$.form.complement.$dirty) return errors;
      this.v$.form.complement.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthComplement'))
      return errors;
    },
    districtErrors() {
      const errors = [];
      if (!this.v$.form.district.$dirty) return errors;
      this.v$.form.district.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthNeigh'))
      this.v$.form.district.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredNeigh'))
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.v$.form.city.$dirty) return errors;
      this.v$.form.city.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthCity'))
      this.v$.form.city.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredCity'))
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.v$.form.state.$dirty) return errors;
      this.v$.form.state.maxLength.$invalid &&
        errors.push(this.$t('accountSettings.address.err.minLengthState'))
      this.v$.form.state.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredState'))
      return errors;
    },
    zipCodeErrors() {
      const errors = [];
      if (!this.v$.form.zipCode.$dirty) return errors;
      this.v$.form.zipCode.minLength.$invalid && errors.push(this.$t('accountSettings.address.err.correctZIP'))
      this.v$.form.zipCode.required.$invalid && errors.push(this.$t('accountSettings.address.err.requiredZIP'))
      return errors;
    },
  },
  methods: {
    prevent(event) {
      event.stopPropagation()
    },
    changeZipCode() {
      this.v$.form.zipCode.$touch();
      if (this.form.zipCode.length) {
        this.zipLoading = true
        if (this.form.zipCode.length == 9 && this.$root.auth.whitelabel.country == 'Brasil') {
          const req = axios.create();
          delete req.defaults.headers.common["X-Requested-With"];
          delete req.defaults.headers.common["Access-Control-Allow-Origin"];
          delete req.defaults.headers.common["useCredentails"];
          req
            .get(`https://viacep.com.br/ws/${this.form.zipCode}/json`)
            .then((res) => {
              if (res && res.data && res.data.uf) {
                this.zipLoading = false
                this.form.street = res.data.logradouro;
                this.form.district = res.data.bairro;
                this.form.city = res.data.localidade;
                this.form.state = res.data.uf;
              }
              else {
                console.error('No addresses were find.')
                this.zipLoading = false
              }
            }, (err) => {
              this.zipLoading = false
              console.error('An error occurred while trying to get zipcode BR')
            });
        }
        if (this.form.zipCode.length == 5 && this.$root.auth.whitelabel.country == 'Peru') {
          const url = `assets/autocomplete/${this.form.zipCode}/pe`;
          this.$axios.get(url).then((response) => {
            // this.address.street = res.data.logradouro;
            console.log('response', response.data.data.results)
            const res = response.data.data.results.range_codes_details
            if (res.length) {
              this.form.district = res[0].city;
              this.form.city = res[0].province;
              this.form.state = res[0].state_name;
              this.form.country = 'Peru';
              this.zipLoading = false
            }
            else {
              this.zipLoading = false
              console.error('No addresses were find.')
            }
          }, (err) => {
            this.zipLoading = false
            console.error('An error occurred while trying to get zipcode')
          })
        }
      }
    },
    save() {
      this.v$.$touch()
      if (this.v$.$invalid) return false;
      this.loading = true;
      let form = this.form;
      if (!form.country)
        form.country = this.countryConfig.name

      if(!this.addressCounter){
        form.main = 1
      }
      if (this.item.id) {
        const url = `address/${this.item.id}`;
        this.$axios
          .put(
            url,
            form
          )
          .then(
            () => {
              this.loading = false;
              form.resume = `${form.street} ${form.number} - ${form.district} - ${form.city}`;

              this.$emit("update", form);
            },
            (err) => {
              this.loading = false;

              console.error("error on updating address", err);
            }
          );
      } else {
        const url = `address`;

        this.$axios
          .post(
            url,
            form
          )
          .then(
            (addr) => {
              this.$emit("update", form);
            },
            (err) => {
              this.loading = false;

              console.error("error on inserting address", err);
            }
          );
      }
    },
    emit(addr) {
      console.log("address added", addr);
      console.log("id", addr.data.id);
      const id = addr.data.id;
      this.form.resume = `${this.form.street} ${this.form.number} - ${this.form.district} - ${this.form.city}`;
      this.form.id = id;
      console.log("emitting form", this.form);
      this.$emit("add-address", this.form, -1);
      this.loading = false;
    },
    remove() {
      this.deleting = true;
      if (this.item.id) {
        const url = `address/${this.item.id}`;

        this.$axios
          .delete(url)
          .then(
            () => {
              this.removeDialog = false;
              this.deleting = false;
              this.$emit("remove", this.item);
            },
            (err) => {
              this.deleting = false;
              console.log("ERR", err.response.data);
            }
          );
      } else {
        this.$emit("remove", this.item);
      }
    },
  },
};
</script>

<style lang="scss">
.text-nowrap {
  word-break: normal;
}

.quiz-company {
  .col {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>